var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_81_752)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2,
    width: 53,
    height: 53,
    rx: 26.5,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_81_752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7467 15.4478H13.3027C12.9552 15.4478 12.622 15.5858 12.3763 15.8315C12.1306 16.0772 11.9926 16.4104 11.9926 16.7579V39.0308C11.9926 39.7257 12.2686 40.3922 12.76 40.8836C13.2514 41.375 13.9179 41.6511 14.6129 41.6511H43.4366C44.1315 41.6511 44.798 41.375 45.2894 40.8836C45.7808 40.3922 46.0569 39.7257 46.0569 39.0308V16.7579C46.0569 16.4104 45.9189 16.0772 45.6732 15.8315C45.4275 15.5858 45.0942 15.4478 44.7467 15.4478ZM29.0247 29.3929L16.6715 18.0681H41.378L29.0247 29.3929ZM24.2279 28.5494L14.6129 37.3619V19.7369L24.2279 28.5494ZM26.1669 30.3263L28.1322 32.136C28.3739 32.3579 28.6901 32.481 29.0182 32.481C29.3463 32.481 29.6625 32.3579 29.9042 32.136L31.8694 30.3263L41.3682 39.0308H16.6715L26.1669 30.3263ZM33.8216 28.5494L43.4366 19.7353V37.3636L33.8216 28.5494Z",
    fill: "#1D1D1D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_81_752",
    x: 0.5,
    y: 0,
    width: 57,
    height: 57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_81_752"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_81_752",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_81_752",
    x: 9.99255,
    y: 13.4478,
    width: 38.0643,
    height: 30.2034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_81_752"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_81_752",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSocial);
export default __webpack_public_path__ + "static/media/mailSocial.68b057dbd6d0c1fc53da9bdb3daefbed.svg";
export { ForwardRef as ReactComponent };